import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EventDefinitionsStore } from "stores/event-definitions/EventDefinitionsStore";
import { defaultOnError } from "util/conditional/onError";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
export const fetchEventDefinitions = (searchParams) => {
  CurrentUserStore.update(CurrentUserStore.getInitialState().currentUser.username);
  return EventDefinitionsStore.searchPaginated(searchParams.page, searchParams.pageSize, searchParams.query, {
    sort: searchParams == null ? void 0 : searchParams.sort.attributeId,
    order: searchParams == null ? void 0 : searchParams.sort.direction,
    filters: FiltersForQueryParams(searchParams.filters)
  }).then(({ elements, pagination, attributes }) => ({
    list: elements,
    pagination,
    attributes
  }));
};
export const fetchEventDefinition = (eventDefinitionId) => EventDefinitionsStore.get(eventDefinitionId).then(({ event_definition, context, is_mutable }) => ({
  eventDefinition: event_definition,
  context,
  is_mutable
}));
export const keyFn = (searchParams) => ["eventDefinition", "overview", searchParams];
export const useGetEventDefinition = (eventDefinitionId) => {
  const { data, isFetching } = useQuery({
    queryKey: ["get-event-definition", eventDefinitionId],
    queryFn: () => defaultOnError(
      fetchEventDefinition(eventDefinitionId),
      "Loading Event Definition failed with status",
      "Could not load Event definition"
    )
  });
  return {
    data: isFetching ? null : data,
    isFetching
  };
};
const useEventDefinitions = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchEventDefinitions(searchParams),
      "Loading Event Definitions failed with status",
      "Could not load Event definition"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading
  };
};
export default useEventDefinitions;
